import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,{attrs:{"dense":""}},[_c(VCol,{attrs:{"cols":"12","xs":"12","sm":"12"}},[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }